import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useOutfitFlyoutOpenedState = () => {
  const {open, isOpen, cancel, hide} = useOpenedStateManager('outfit-flyout');

  return {
    open,
    close: cancel,
    hideFlyout: hide,
    isOpen,
  };
};
